import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const STATUS_MAP = {
  Telat: { type: 'error', i18nKey: 'badgeStatus.late' },
  'Pulang Lebih Awal': { type: 'error', i18nKey: 'badgeStatus.earlyLeave' },
  'Diluar Area': { type: 'error', i18nKey: 'badgeStatus.outsideArea' },
  'Lokasi Tidak Valid': { type: 'error', i18nKey: 'badgeStatus.invalidLocation' },
  'Tidak Live': { type: 'error', i18nKey: 'badgeStatus.notLive' },
  'Tidak Clock Out': { type: 'error', i18nKey: 'badgeStatus.notClockOut' },
  'Tepat Waktu': { type: 'success', i18nKey: 'badgeStatus.onTime' },
  'Area Sesuai': { type: 'success', i18nKey: 'badgeStatus.validArea' },
};

const BadgeStatus = ({ status }) => {
  const { t } = useTranslation('report-attendance-host-detail');
  const { type = 'default', i18nKey } = STATUS_MAP[status] || {};

  return (
    <Box className={`${styles['badge-status__container']} ${styles[`badge-status__container--${type}`]}`}>
      <TextRegular className={`${styles['badge-status__text']} ${styles[`badge-status__text--${type}`]}`}>{i18nKey ? t(i18nKey) : status}</TextRegular>
    </Box>
  );
};

export default BadgeStatus;
